'use client';

import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './HeraHeader.module.scss';
import { HeraHeaderProps } from '@/types/header.types';
import Link from 'next/link';
// import { useRouter } from 'next/navigation';
// import FooterButton from '../Footer/components/FooterButton/FooterButton';
import { useState, useCallback } from 'react';
import SidebarMenu from './SidebarMenu/SidebarMenu';
import {
  sideBarData1,
  sideBarData2,
  sideBarData3,
  sideBarData4,
} from '@/data/sideBar.data';
import DropdownItem from './DropdownItem/DropdownItem';
import HeaderSearch from './HeaderSearch/HeaderSearch';

const NavbarLink1 = ({
  about,
  href = '#',
}: {
  about: string;
  href?: string;
}) => (
  <Link href={href} className={styles.navLink}>
    {about}
  </Link>
);

const HeraHeader: NextPage<HeraHeaderProps> = ({
  className = '',
  state = 'Desktop',
}) => {
  // const router = useRouter();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleBackdropClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        setIsSidebarOpen(false);
      }
    },
    []
  );

  return (
    <>
      <div
        className={[styles.heraheader, className].join(' ')}
        data-state={state}
      >
        <Link href="/" className={styles.logoLink}>
          <Image
            className={styles.logoIcon}
            width={66}
            height={66}
            sizes="100vw"
            alt="Logo"
            src="/img/header/logo-mob1.png"
          />
          <Image
            className={styles.logoIcon1}
            loading="lazy"
            width={167}
            height={68}
            sizes="100vw"
            alt="Logo Extended"
            src="/img/header/logo-desc1.png"
          />
        </Link>

        <HeaderSearch />

        <div className={styles.navbarMenu}>
          <nav className={styles.items}>
            <DropdownItem data={sideBarData1} />
            <DropdownItem data={sideBarData2} />
            {/* <DropdownItem data={sideBarData3} /> */}

            <NavbarLink1 href="/charter" about="Charter Flights" />
            <NavbarLink1 href="/empty-leg-flights" about="Empty Leg Flights" />
            <DropdownItem data={sideBarData4} />
            {/* <NavbarLink1 href="/hera-jet-card-membership" about="Jet Card" /> */}
            <NavbarLink1 href="/available-fleet" about="Available Fleet" />
            <NavbarLink1 href="/blog" about="Blog" />
            <NavbarLink1 href="/contact" about="Contacts" />
          </nav>
          {/* <FooterButton
            color="accent"
            highContrast={false}
            loading={false}
            size={3}
            state="default ✦"
            variant="solid ✦"
            text="Log In"
            iconStart={false}
            iconEnd={false}
            focusRing={false}
            onClick={() => router.push('/loginPage')}
          /> */}

          <div
            className={styles.burgerbutton}
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {isSidebarOpen ? (
              <Image
                className={styles.burgerbutton}
                loading="lazy"
                width={32}
                height={32}
                sizes="100vw"
                alt="Logo Extended"
                src="/img/header/close.svg"
              />
            ) : (
              <Image
                className={styles.burgerbutton}
                loading="lazy"
                width={32}
                height={32}
                sizes="100vw"
                alt="Logo Extended"
                src="/img/header/hamburger-menu.svg"
              />
            )}
          </div>
        </div>
      </div>

      <div
        className={`${styles.sidebarWrapper} ${isSidebarOpen ? styles.open : ''}`}
        onClick={handleBackdropClick}
      >
        <div className={styles.sidebarContent}>
          <SidebarMenu onClose={() => setIsSidebarOpen(false)} />
        </div>
      </div>
    </>
  );
};

export default HeraHeader;
